<template>
  <div id="admin">
    <!--左边-->
    <ce-bian-lang></ce-bian-lang>
    <!--右边内容-->
    <container></container>
  </div>
</template>

<script>
import ceBianLang from "@/admin/ceBianLan/ceBianLang";
import container from "@/admin/container/container";
export default {
  components: {
    ceBianLang,
    container,
  },
  created(){
    //初始化侧边栏数据和 head 数据
    this.$store.getters.getTags 
    this.$store.getters.getNavList 
    this.$store.getters.geTroutePath 
  }
};
</script>

<style lang="scss" scoped>
</style>